import React from 'react';
import { Loader } from 'lucide-react';

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <Loader className="spinner" size={48} />
      <h2>Analyzing visa requirements...</h2>
      <p>Searching official sources for accurate information</p>
    </div>
  );
};

export default LoadingScreen;